import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import { Link } from "react-router-dom";
import TeamTwo from "../team/TeamTwo";


export default function VideoPromoTwo() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <section
        id="download"
        className="video-promo ptb-100 background-img"
        style={{
          background:
            "url('assets/img/video-bg.jpg')no-repeat center center / cover",
        }}
      >
        <TeamTwo/>
      </section>
    </>
  );
}
